module.exports = __webpack_public_path__ + "static/umbrellapeople-167121d65f58a56f1b1c11179040a7fb.jpg";